<template>
	<seccion-contactos></seccion-contactos>
</template>
<script>
import SeccionContactos from './contactos/contactos'

export default {
	components: {
		'seccion-contactos': SeccionContactos
	},
	data () {
		return {}
	}
}
</script>

<style scoped>
	div.cabecera {
		position: relative;
		display: block;
		top: 0;
		left: 0;
		right: 0;
		height: 50px;
		margin-top: -20px;
	}
	div.cabecera > ul {
		position: relative;
		display: block;
		margin: 0;
		padding: 0;
	}

	div.cabecera > ul > li {
		position: relative;
		display: inline-block;
		padding: 10px;
		height: 50px;
		cursor: pointer;
		text-align: center;
		margin: 0
	}

	div.cabecera > ul > li.active {
		background-color: #f0f0f0 !important;
		color: black !important;
	}

	div.cabecera > ul > li:hover {
		background-color: #555555;
		color: white;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/libreta-direcciones/vue/App.vue